import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTopLevelCustomEventsRequest, getTopLevelCustomEvents } from 'modules/workflows/ducks';
import { ResourceTypeaheadSelect } from '../../../editorComponents/ResourceTypeaheadSelect/ResourceTypeaheadSelect';
import { ResourceComponentProps } from './types';

export const ResourceCustomEventSelect = ({
  onChange,
  value,
  placeholder,
  isError,
  noResourceHelpText,
  ...props
}: ResourceComponentProps) => {
  const dispatch = useDispatch();
  const events = useSelector(getTopLevelCustomEvents) || [];

  useEffect(() => {
    if (!events.length) {
      dispatch(fetchTopLevelCustomEventsRequest());
    }
  }, []);

  return (
    <ResourceTypeaheadSelect
      value={value}
      onChange={onChange}
      options={events?.map((event: string) => ({
        id: event,
        value: event,
        label: event,
      }))}
      placeholder={placeholder}
      isError={isError}
      noResourceHelpText={noResourceHelpText ?? ''}
      {...props}
    />
  );
};
